import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import Field from './Field';

const Row = ({ severity, rowData } = {}) => <Field key={uuid()} severity={severity} details={rowData} />;

Row.propTypes = {
  severity: PropTypes.string,
  rowData: PropTypes.array
};

export default Row;
